import { LegalLayout, LegalSection } from "@/components/LegalLayout";
import { GlowCard } from "@/components/GlowCard";
import { COMPANY } from "@/content/galaxy";

export default function Datenschutz() {
  return (
    <LegalLayout badge="RECHTLICHES" title="DATENSCHUTZ" testId="datenschutz-page">
      <p className="text-white/55">
        Datenschutzerklärung gemäß der EU-Datenschutz-Grundverordnung (DSGVO) und dem
        österreichischen Datenschutzgesetz (DSG).
      </p>

      <GlowCard className="p-6">
        <LegalSection heading="1. Verantwortlicher">
          <p>
            Verantwortlich für die Datenverarbeitung auf dieser Website im Sinne der DSGVO ist:
          </p>
          <p className="text-white">{COMPANY.legalName}</p>
          <p>
            {COMPANY.street}
            <br />
            {COMPANY.zip} {COMPANY.city}, {COMPANY.country}
            <br />
            E-Mail:{" "}
            <a
              href={`mailto:${COMPANY.email}`}
              data-testid="datenschutz-email-link"
              className="text-gl-blue2 transition-colors hover:text-white"
            >
              {COMPANY.email}
            </a>
            <br />
            Telefon: {COMPANY.phone}
          </p>
        </LegalSection>
      </GlowCard>

      <GlowCard className="p-6">
        <LegalSection heading="2. Allgemeines zur Datenverarbeitung">
          <p>
            Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies zur
            Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und Leistungen
            erforderlich ist. Die Verarbeitung erfolgt regelmäßig nur nach Einwilligung der Nutzer
            oder soweit eine gesetzliche Grundlage dies gestattet (Art. 6 DSGVO).
          </p>
        </LegalSection>
      </GlowCard>

      <GlowCard className="p-6">
        <LegalSection heading="3. Server-Logfiles & Hosting">
          <p>
            Beim Aufruf dieser Website werden durch den Hosting-Anbieter automatisch Informationen
            in sogenannten Server-Logfiles gespeichert (z. B. Browsertyp, Betriebssystem,
            Referrer-URL, IP-Adresse und Uhrzeit des Zugriffs). Diese Daten sind nicht bestimmten
            Personen zuordenbar und dienen ausschließlich der technischen Bereitstellung und
            Sicherheit der Website. Rechtsgrundlage ist unser berechtigtes Interesse (Art. 6 Abs. 1
            lit. f DSGVO).
          </p>
        </LegalSection>
      </GlowCard>

      <GlowCard className="p-6">
        <LegalSection heading="4. Team-Anmeldung / Kontaktformular">
          <p>
            Wenn du über unser Anmeldeformular eine Team-Bewerbung absendest, verarbeiten wir die
            von dir eingegebenen Daten (z. B. Name, E-Mail-Adresse, Teamname, Kapitän,
            Influencer-Handle), um deine Anfrage zu bearbeiten und mit dir Kontakt aufzunehmen.
          </p>
          <p>
            Die Übermittlung des Formulars erfolgt technisch über den Dienst{" "}
            <span className="text-white">Web3Forms</span>. Dabei werden die Formulardaten
            verarbeitet und per E-Mail an uns weitergeleitet. Rechtsgrundlage ist Art. 6 Abs. 1 lit.
            b DSGVO (Anbahnung eines Vertragsverhältnisses) sowie unser berechtigtes Interesse an der
            Kontaktaufnahme.
          </p>
          <p>
            Wir speichern diese Daten so lange, wie es für die Bearbeitung deiner Bewerbung
            erforderlich ist, und löschen sie anschließend, sofern keine gesetzlichen
            Aufbewahrungspflichten entgegenstehen.
          </p>
        </LegalSection>
      </GlowCard>

      <GlowCard className="p-6">
        <LegalSection heading="5. Cookies">
          <p>
            Diese Website verwendet nur technisch notwendige Cookies bzw. Speichermechanismen, die
            für den Betrieb der Seite erforderlich sind. Es werden keine Tracking- oder
            Marketing-Cookies ohne deine Einwilligung gesetzt.
          </p>
        </LegalSection>
      </GlowCard>

      <GlowCard className="p-6">
        <LegalSection heading="6. Weitergabe an Dritte">
          <p>
            Eine Übermittlung deiner persönlichen Daten an Dritte erfolgt nur, wenn dies zur
            Vertragsabwicklung notwendig ist, du ausdrücklich eingewilligt hast oder wir gesetzlich
            dazu verpflichtet sind. Eingesetzte Dienstleister (z. B. Hosting, Web3Forms) wurden
            sorgfältig ausgewählt und verarbeiten Daten als Auftragsverarbeiter nach unseren
            Weisungen.
          </p>
        </LegalSection>
      </GlowCard>

      <GlowCard className="p-6">
        <LegalSection heading="7. Deine Rechte">
          <p>Dir stehen gegenüber uns folgende Rechte hinsichtlich deiner Daten zu:</p>
          <ul className="list-disc space-y-1 pl-5">
            <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
            <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
            <li>Recht auf Löschung (Art. 17 DSGVO)</li>
            <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
            <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
            <li>Recht auf Widerspruch (Art. 21 DSGVO)</li>
          </ul>
          <p>
            Zur Ausübung deiner Rechte genügt eine E-Mail an{" "}
            <a
              href={`mailto:${COMPANY.email}`}
              className="text-gl-blue2 transition-colors hover:text-white"
            >
              {COMPANY.email}
            </a>
            .
          </p>
        </LegalSection>
      </GlowCard>

      <GlowCard className="p-6">
        <LegalSection heading="8. Beschwerderecht bei der Aufsichtsbehörde">
          <p>
            Wenn du der Ansicht bist, dass die Verarbeitung deiner Daten gegen das Datenschutzrecht
            verstößt, hast du das Recht, dich bei der österreichischen Datenschutzbehörde zu
            beschweren:
          </p>
          <p>
            Österreichische Datenschutzbehörde, Barichgasse 40–42, 1030 Wien —{" "}
            <a
              href="https://www.dsb.gv.at"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="datenschutz-dsb-link"
              className="text-gl-blue2 transition-colors hover:text-white"
            >
              www.dsb.gv.at
            </a>
          </p>
        </LegalSection>
      </GlowCard>

      <p className="text-xs text-white/40">Stand: {COMPANY.lastUpdated}</p>
    </LegalLayout>
  );
}
